import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../resources/auth/authentication.service';
import { UserService } from '../../../resources/auth/user.service';
import { User } from '../../../resources/models/user.model';

@Component({
  selector: 'enrich-client-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.sass'],
})
export class UserDropdownComponent implements OnInit {
  user: User;

  constructor(
    private router: Router,
    private userService: UserService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.userService.user.subscribe((user: User) => {
      this.user = user;
    });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/client/user-dropdown/user-dropdown.component.ts